import { useWrite, HookshotError } from '@bw/hookshot';

import config from 'utils/config';

/**
 * How the customer asked to receive their one-time code. Choosing `SMS` is
 * itself the consent record for the text message -- see the disclosure on the
 * verification page -- so nothing else about consent goes over the wire.
 */
export type DeliveryChannel = 'SMS' | 'VOICE';

type UseSendTNVerification = {
  input: {
    phoneNumber: string;
    email: string;
    deliveryChannel: DeliveryChannel;
  };
};

export interface SendTNResponse {
  message: string;
  status: string;
}

export const useSendTNVerification = () => {
  return useWrite<UseSendTNVerification, SendTNResponse>(
    `${config.kongBaseUrl}/v1/express/registration/code`,
    'POST',
    {
      requestFormat: 'json',
      fetchOptions: {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
      transformError: (err) =>
        err
          ? new HookshotError(err.response, err.data?.errors?.[0]?.description)
          : err,
    },
  );
};
